import { api } from './client';
import { longRequest } from './requestTimeout';
import type {
  InviteResponse,
  InviteListResponse,
  InviteInfoResponse,
  AcceptInviteResponse,
  CreateInviteLinkPayload,
  SendInviteEmailsPayload,
} from '@/types';

export const projectInvitesApi = {
  createLink: (projectId: string, data: CreateInviteLinkPayload) =>
    api.post<InviteResponse>(`/projects/${projectId}/invites/link`, data),

  sendEmails: (projectId: string, data: SendInviteEmailsPayload) =>
    api.post<{ invites: InviteResponse[] }>(
      `/projects/${projectId}/invites/emails`,
      data,
      longRequest('inviteEmails'),
    ),

  list: (projectId: string) =>
    api.get<InviteListResponse>(`/projects/${projectId}/invites`),

  revoke: (projectId: string, inviteId: string) =>
    api.patch<{ success: boolean; message: string }>(
      `/projects/${projectId}/invites/${inviteId}/revoke`,
    ),

  deleteInvite: (projectId: string, inviteId: string) =>
    api.delete<{ success: boolean; message: string }>(
      `/projects/${projectId}/invites/${inviteId}`,
    ),

  // WEB-1444: повторная отправка недоставленного письма-приглашения.
  // Возвращает обновлённый инвайт (emailDeliveryFailed сброшен при успехе).
  resendEmail: (projectId: string, inviteId: string) =>
    api.post<InviteResponse>(
      `/projects/${projectId}/invites/${inviteId}/resend-email`,
    ),

  // Public — no JWT required to view; uses token in URL path
  getByToken: (token: string) =>
    api.get<InviteInfoResponse>(`/invites/${token}`),

  accept: (token: string) =>
    api.post<AcceptInviteResponse>('/invites/accept', { token }),
};
